<template>
	<BaseCmsRotator
		:fetch="{code: featuredPromo, limit: 20, response_fields: ['id','link','link_target_blank','url_without_domain','title','code','template','image','image_thumbs','image_2_thumbs','image_upload_path','image_2_upload_path','image_3_upload_path','element_color_4']}"
		:ga4="'home - featured - '"
		@loadRotatorItems="loadRotatorItems"
		v-slot="{items}">
		<div v-if="items?.length" class="hp-featured-promo" :class="{'extra': mode == 'extra'}">
			<div v-if="labels.get('homepage_featured_promo_title') != 'homepage_featured_promo_title'" class="hp-featured-promo-header hp-section-header">
				<div class="hp-featured-promo-title hp-title">
					<template v-if="mode == 'extra'">{{ labels.get('homepage_featured_extra_promo_title') }}</template>
					<template v-else>{{ labels.get('homepage_featured_promo_title') }}</template>
				</div>
			</div>

			<div class="hp-featured-promo-slider">
				<BaseUiSwiper
					:options="{
						slidesPerView: 4,
						slidesPerGroup: 4,
						spaceBetween: 20,
						breakpoints: {
							0: {
								enabled: false
							},
							980: {
								enabled: true
							}
						}
					}">
					<BaseUiSwiperSlide v-for="item in items" :key="item.id">
						<NuxtLink
							v-if="item.link"
							:target="item.link_target_blank == 1 ? '_blank' : null"
							:to="item.url_without_domain"
							@click="gtm.gtmPromoClick(item.title, 'home - featured - ', index, item.code, item.template)"
							class="hp-fpromo-item link"
							:class="['hp-fpromo-item-' + item.id]"
							:aria-label="item.title">
							<div class="hp-fpromo-item-box">
								<div v-if="item.image_upload_path" class="hp-fpromo-item-img">
									<BaseUiImage
										loading="eager"
										:data="item.image_thumbs?.['width355-height180-crop1']"
										default="/images/no-image-355x180.webp"
										:picture="[{maxWidth: '760px', src: item.image_2_thumbs?.['width390-height270-crop1']?.thumb ? item.image_2_thumbs?.['width390-height270-crop1']?.thumb : item.image_thumbs?.['width355-height180-crop1']?.thumb, default: '/images/no-image-50.webp'}]" />
								</div>
								<div v-else-if="!item.image && item.element_color_4" class="hp-fpromo-item-bg" :style="{'background': item.element_color_4}"></div>
								<div v-if="item.image_3_upload_path" class="hp-fpromo-item-icon">
									<BaseUiImage loading="eager" :src="item.image_3_upload_path" width="75" height="75" />
								</div>
							</div>
							<div v-if="item.title" class="hp-fpromo-item-title">{{ item.title }}</div>
						</NuxtLink>
						<div v-else class="hp-fpromo-item" :class="['hp-fpromo-item-' + item.id]">
							<div class="hp-fpromo-item-box">
								<div v-if="item.image_upload_path" class="hp-fpromo-item-img">
									<BaseUiImage
										loading="eager"
										:data="item.image_thumbs?.['width355-height180-crop1']"
										default="/images/no-image-355x180.webp"
										:picture="[{maxWidth: '760px', src: item.image_2_thumbs?.['width390-height270-crop1']?.thumb ? item.image_2_thumbs?.['width390-height270-crop1']?.thumb : item.image_thumbs?.['width355-height180-crop1']?.thumb, default: '/images/no-image-50.webp'}]" />
								</div>
								<div v-else-if="!item.image && item.element_color_4" class="hp-fpromo-item-bg" :style="{'background': item.element_color_4}"></div>
								<div v-if="item.image_3_upload_path" class="hp-fpromo-item-icon">
									<BaseUiImage loading="eager" :src="item.image_3_upload_path" width="75" height="75" />
								</div>
							</div>
							<div v-if="item.title" class="hp-fpromo-item-title">{{ item.title }}</div>
						</div>
					</BaseUiSwiperSlide>
				</BaseUiSwiper>
			</div>
		</div>
	</BaseCmsRotator>
</template>

<script setup>
	const labels = useLabels();
	const props = defineProps({
		mode: {
			type: String,
			default: ''
		},
	});
	const gtm = useGtmBB();

	let featuredPromo = 'featured_promo';
	if (props.mode == 'extra') {
		featuredPromo = 'featured_promo_extra';
	}

	//gtm
	function loadRotatorItems(value) {
		if (value?.items?.length) {
			value?.items.forEach((item, index) => {
				let template = ''
				if(item?.template == 'template_hp_promo_big') {
					template = 'big -';
				} else if(item?.template == 'template_hp_promo_medium') {
					template = 'medium -';
				}
				gtm.viewPromotion({
					creative_name: item.title || '',
					creative_slot: value.creativeSlot + template + (index + 1),
					promotion_id: item.code || '',
					promotion_name: item.title || '',
				});
			});
		}
	}
</script>

<style lang="less" scoped>
	.hp-featured-promo-slider{
		min-height: 180px; background: @white; position: relative;
		:deep(.swiper){
			display: flex; align-items: center; width: calc(~'100% - -40px'); margin-left: -20px; padding: 0 20px; position: relative; height: 210px; overflow: hidden;
			@media (max-width: 1440px){height: 185px;}
			@media (max-width: 1350px){height: 175px;}
			@media (max-width: @t){height: auto;}
			&:before, &:after{.pseudo(15px, auto); background: @white; top: 0; bottom: 0; left: 0; z-index: 11;}
			&:after{left: unset; right: 0;}
		}
		:deep(.swiper-slide){width: auto; margin-right: 20px;}

		@media (max-width: @l){min-height: 100px;}
		@media (max-width: @t){
			:deep(.swiper){
				width: 100%; margin: 0; padding: 0;
				&:before, &:after{content: none;}
			}
		}
		@media (max-width: @m) {
			width: calc(~'100% - -40px'); margin: 0 0 0 -20px;
			:deep(.swiper-wrapper) {
				display: flex; padding: 0 0 0 20px; overflow-y: hidden; white-space: normal; position: relative;
				&::-webkit-scrollbar{display: none;}
				&::-webkit-scrollbar-thumb{display: none;}
			}
			:deep(.swiper-slide){flex-shrink: unset; min-width: 40%; margin-right: 10px; white-space: normal;}
		}
		@media (max-width: @ms) {
			width: calc(~'100% - -30px'); min-height: 160px; margin: 0 0 0 -15px;
			:deep(.swiper-wrapper){padding: 0 0 0 15px;}
			:deep(.swiper-slide){min-width: 70%;}
		}
	}
	.hp-featured-promo{
		max-width: 1920px; width: 1480px; min-height: 200px; margin: 0 auto 45px;
		&.extra{margin-bottom: 70px;}

		@media (max-width: @l){width: auto; margin: 0 70px 45px;}
		@media (max-width: @t){margin: 0 30px 45px;}
		@media (max-width: @m){min-height: 150px; margin: 0 20px 35px;}
		@media (max-width: @ms){
			margin: 0 15px 25px;
			&.extra{margin-bottom: 50px;}
		}
	}
	.hp-fpromo-item{
		display: block; padding: 15px 0; font-size: 20px; line-height: 27px; text-decoration: none; color: @textColor; position: relative;
		:deep(img){width: auto; height: auto; max-width: 100%; max-height: 100%; display: block; .transition(all);}
		@media (min-width: @t){
			&:hover{text-decoration: none; color: @textColor;}
			&.link:hover{
				.hp-fpromo-item-bg, .hp-fpromo-item-img :deep(img){box-shadow: 0 6px 10px 0 rgba(1, 61, 112, 0.3);}
			}
		}

		@media (max-width: @t){padding: 0;}
		@media (max-width: @m){display: block; padding: 0; margin: 0; white-space: normal;}
	}
	.hp-fpromo-item-box{width: 100%; position: relative; display: flex; align-items: center; justify-content: center;}
	.hp-fpromo-item-bg{
		width: 100%; height: auto; max-width: 100%; max-height: 100%; padding-bottom: 50.705%; display: flex; align-items: center; justify-content: center; .transition(box-shadow);

		@media (max-width: @ms){padding-bottom: 69.23%;}
	}
	.hp-fpromo-item-icon{
		position: absolute;
		:deep(img){width: auto; height: auto; max-width: 75px; max-height: 75px; display: block;}

		@media (max-width: @t){
			:deep(img){max-width: 60px; max-height: 60px;}
		}
		@media (max-width: @ms){
			:deep(img){max-width: 40px; max-height: 40px;}
		}
	}
	.hp-fpromo-item-title{
		text-align: center; padding: 22px 15px 0;

		@media (max-width: @t){font-size: 16px; line-height: 22px; padding: 15px 10px 0;}
		@media (max-width: @ms){padding: 10px 10px 15px;}
	}
	:deep(.swiper-navigation){
		@media (max-width: @m){display: none;}
	}
</style>
